import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class ProNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {
                'id': 'applications',
                'title': '',
                'translate': 'NAV.APPLICATIONS',
                'type': 'group',
                'icon': 'apps',
                'children': [
                    // {
                    //     'id': 'home',
                    //     'title': 'Home',
                    //     'type': 'item',
                    //     'icon': 'home',
                    //     'url': 'apps/home',
                    // },
                    // {
                    //     //
                    // },
                    /** Logout button */
                    {
                        'id': 'logout',
                        'type': 'item',
                    }
                ]
            },
        ];
    }
}




// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/navigation/proNavigation.model.ts